import AICatalystWrapper from './AICatalystWrapper'

export default AICatalystWrapper
